module.exports = __webpack_public_path__ + "img/aniversary_blue.9474d5fd.png";